export default __webpack_public_path__ + "static/media/card-american-express.e81d2340.svg";